export const ErrorFace = ({ classname }) => {
  return (
    <svg
      className={classname}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 23L29.234 32.234"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M29.2341 23L20.0001 32.234"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M41.7659 23L50.9999 32.234"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M51 23L41.766 32.234"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="35" cy="35" r="34.5" stroke="#00FFF0" />
      <path
        d="M30 51H39.5"
        stroke="#00FFF0"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}
